var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpcoin16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 0a1.0001 1.0001 0 0 0-0.70703 0.29297l-7 7a1.0001 1.0001 0 0 0 0.70703 1.707h3v6a1.0001 1.0001 0 0 0 1 1h4.0078c-1.217-0.9143-2.0078-2.3699-2.0078-4 0-2.7496 2.2504-5 5-5 1.4766 0 2.8091 0.64899 3.7266 1.6758a1.0001 1.0001 0 0 0-0.0195-1.3828l-7-7a1.0001 1.0001 0 0 0-0.70706-0.29297z",
    color: "#000000",
    fill: "#afc6e9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 12a4 4 0 0 1-4 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 4 4z",
    color: "#000000",
    fill: "#d4aa00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.69 9.0371a0.50005 0.50005 0 0 0-0.54493 0.10938l-2.5 2.5 0.70704 0.70703 1.6465-1.6465v4.293h1v-5.5a0.50005 0.50005 0 0 0-0.30859-0.46289z",
    color: "#000000",
    fill: "#fff",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoin16);
export default __webpack_public_path__ + "static/media/up.coin.16.4bfda80011d89c0ea70f04054d1a137e.svg";
export { ForwardRef as ReactComponent };